<template>
  <div class="banner">
    <el-carousel height="320px" :interval="5000"
      arrow="always"
    >
      <el-carousel-item v-for="(item, index) in fiveSDataList" :key="index">
        <el-image
          @click="get5sDetail(item)"
          class="banner-item"
          :src="item.url || defaultImg"
          :alt="item.name"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { openOther } from "@/utils/index";
import { getAccessToken } from "@/utils/userInfo";
export default {
  data() {
    return {
      defaultImg: require("@/assets/img/bitmap.png"),
      fiveSDataList: [],
    };
  },
  created() {
    this.get5s();
  },
  methods: {
    // 获取5S店轮播图
    get5s() {
      this.$request
        .get(`/front/user/home/homeRotationChart/selectRotationChartList/1`, {
          // params: { detailed: false }
        })
        .then((data) => {
          console.log("get5s", data);
          this.fiveSDataList = data;
        });
    },
    get5sDetail(item) {
      if (
        item.httpAddress !== "" &&
        item.httpAddress !== null &&
        item.httpAddress !== undefined
      ) {
        if (item.jump === "1") {
          if (!item.ssoCode) {
            openOther(item.httpAddress, true);
          } else {
            const token = getAccessToken();
            // 外部链接特殊处理
            switch (item.ssoCode) {
              case "TPT":
                if (!token) {
                  this.$router.push({ name: "login" });
                  return;
                }
                this.$http
                  .get(`/inter/thirdPartyAuth/getAuthCode?client_id=TPT`)
                  .then(({ data: res }) => {
                    if (res.code === 0) {
                      console.log(res.data);
                      window.open(res.data.redirectUrl, "_blank");
                    }
                  });
                break;
            }
          }
        } else if (item.jump === "2" || item.jump === "3") {
          let name = item.httpAddress.split("?")[0];
          let id = item.httpAddress.split("?")[1].split("=")[1];
          this.$router.push({ name: name, query: { id: id } });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 676px;
  height: 320px;
  border-radius: 16px;
  overflow: hidden;
  .banner-item {
    width: 100%;
    cursor: pointer;
  }
}

::v-deep .el-carousel__indicators--horizontal {
  // 原样式left: 50%;会限制宽度为50%；导致指示器换行多
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}
</style>
